export const SPIFF_RULE_EVENTS = {
  signup: "signup",
  referral_creation: "referral_creation",
  referral_completion: "referral_completion",
  five_star_review: "five_star_review",
  yard_sign_photo: "yard_sign_photo",
  pricebook_item_sale: "pricebook_item_sale",
  tech_generated_lead: "tech_generated_lead",
  driving_score: "driving_score",
  generic: "generic",
} as const;

export const SPIFF_RULE_EVENTS_LABELS = {
  [SPIFF_RULE_EVENTS.signup]: "New sign-up",
  [SPIFF_RULE_EVENTS.referral_creation]: "New referral",
  [SPIFF_RULE_EVENTS.referral_completion]: "Referral closed",
  [SPIFF_RULE_EVENTS.five_star_review]: "Five-star review",
  [SPIFF_RULE_EVENTS.yard_sign_photo]: "Yard sign photo",
  [SPIFF_RULE_EVENTS.pricebook_item_sale]: "Pricebook item sale",
  [SPIFF_RULE_EVENTS.tech_generated_lead]: "TGL",
  [SPIFF_RULE_EVENTS.driving_score]: "Driving score",
  [SPIFF_RULE_EVENTS.generic]: "Generic Event",
} as const;

export const SPIFF_RULE_EVENTS_SHORT_LABELS = {
  [SPIFF_RULE_EVENTS.signup]: "Sign-up",
  [SPIFF_RULE_EVENTS.referral_creation]: "New referral",
  [SPIFF_RULE_EVENTS.referral_completion]: "Referral closed",
  [SPIFF_RULE_EVENTS.five_star_review]: "Five-star review",
  [SPIFF_RULE_EVENTS.yard_sign_photo]: "Yard sign",
  [SPIFF_RULE_EVENTS.pricebook_item_sale]: "Pricebook item",
  [SPIFF_RULE_EVENTS.tech_generated_lead]: "TGL",
  [SPIFF_RULE_EVENTS.driving_score]: "Driving",
  [SPIFF_RULE_EVENTS.generic]: "Generic",
} as const;

export const SPIFF_RULE_EVENTS_OPTIONS = {
  [SPIFF_RULE_EVENTS.signup]: "Sign-ups",
  [SPIFF_RULE_EVENTS.referral_creation]: "New Referrals",
  [SPIFF_RULE_EVENTS.referral_completion]: "Referral closed",
  [SPIFF_RULE_EVENTS.five_star_review]: "Five-star reviews",
  [SPIFF_RULE_EVENTS.yard_sign_photo]: "Yard sign photos",
  [SPIFF_RULE_EVENTS.pricebook_item_sale]: "Pricebook item sales",
  [SPIFF_RULE_EVENTS.tech_generated_lead]: "Tech generated leads",
  [SPIFF_RULE_EVENTS.driving_score]: "Driving scores",
  [SPIFF_RULE_EVENTS.generic]: "Generic events",
} as const;

export const SPIFF_RULE_EVENTS_ORDER = [
  SPIFF_RULE_EVENTS.signup,
  SPIFF_RULE_EVENTS.referral_creation,
  SPIFF_RULE_EVENTS.referral_completion,
  SPIFF_RULE_EVENTS.five_star_review,
  SPIFF_RULE_EVENTS.yard_sign_photo,
  SPIFF_RULE_EVENTS.tech_generated_lead,
  SPIFF_RULE_EVENTS.driving_score,
  SPIFF_RULE_EVENTS.pricebook_item_sale,
  SPIFF_RULE_EVENTS.generic,
] as const;

export const SPIFF_RULE_EVENTS_DESCRIPTIONS = {
  [SPIFF_RULE_EVENTS.signup]:
    "Spiff payments to technicians for each new sign-up to the referral program.",
  [SPIFF_RULE_EVENTS.referral_creation]:
    "Spiff payments to technicians for each new referral originated by them.",
  [SPIFF_RULE_EVENTS.referral_completion]:
    "Spiff payments to technicians when a job that was referred from their customers is completed.",
  [SPIFF_RULE_EVENTS.five_star_review]:
    "Spiff payments to technicians for each five star review from a customer on a job they completed.",
  [SPIFF_RULE_EVENTS.yard_sign_photo]:
    "Spiff payments to technicians for each yard sign photo submitted at a customer's location.",
  [SPIFF_RULE_EVENTS.pricebook_item_sale]:
    "Spiff payments to technicians when a specific item from the pricebook is sold.",
  [SPIFF_RULE_EVENTS.tech_generated_lead]:
    "Spiff payments to technicians for each lead they generate.",
  [SPIFF_RULE_EVENTS.driving_score]:
    "Spiff payments to technicians based on their driving score.",
  [SPIFF_RULE_EVENTS.generic]:
    "Spiff payments to technicians for custom events configured by administrators.",
} as const;

export const UNDERLYING_RECORD_TYPES = {
  CUSTOMER: "Customer",
  REFERRAL: "Referral",
  REVIEW: "Review",
  SPIFF_PHOTO: "SpiffPhoto",
  SPIFF_TRIGGER_PLACEHOLDER: "SpiffTriggerPlaceholder",
} as const;

export const SHOWN_SPIFF_RULES = [
  SPIFF_RULE_EVENTS.signup,
  SPIFF_RULE_EVENTS.referral_creation,
  SPIFF_RULE_EVENTS.referral_completion,
  SPIFF_RULE_EVENTS.five_star_review,
  SPIFF_RULE_EVENTS.yard_sign_photo,
  SPIFF_RULE_EVENTS.tech_generated_lead,
  SPIFF_RULE_EVENTS.driving_score,
  SPIFF_RULE_EVENTS.pricebook_item_sale,
] as const;
